import { FieldHasValue } from 'helpers/Validation';

export const AsLeftResultFormulaM68 = (formData) => {
    if (FieldHasValue(formData.F388AltConfirmThatExternalHeatAppliedField) && FieldHasValue(formData.F109AltHmireading1)) {
        if (formData.F388AltConfirmThatExternalHeatAppliedField === 'YES' && formData.F109AltHmireading1 === 'ALARM') {
            return 'PASS';
        }
        return 'FAIL';
    }
    return '';
};
